import React from 'react';
import Spline from '@splinetool/react-spline';
import './HeroSection.css';

const HeroSection = () => {
  const scrollToForm = () => {
    document.getElementById('form-section').scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  const scrollToMore = () => {
    document.getElementById('benefits').scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  return (
    <section id="hero" className="hero">
      {/* Spline 3D Animation Background */}
      <div className="hero__spline-background">
        <Spline scene="https://prod.spline.design/DuIMqryLT7OWdSVp/scene.splinecode" />
      </div>
      
      {/* Overlay para melhorar legibilidade do texto */}
      <div className="hero__background">
        <div className="hero__overlay"></div>
        {/* Gradiente sobre a animação Spline */}
        <div className="hero__gradient"></div>
      </div>
      
      <div className="hero__container container">
        <div className="hero__content">
          <h1 className="hero__title hero__title--desktop">
            Seu site/aplicativo personalizado,{' '}
            <span className="hero__title-highlight">sem complicação</span>
          </h1>
          
          <h1 className="hero__title hero__title--mobile">
            Seu site/app{' '}
            <span className="hero__title-highlight">do seu jeito</span>
          </h1>
          
          <p className="hero__subtitle">
            Transforme sua ideia em realidade. Produzimos sites e aplicativos
            digitais 100% personalizados para a sua ideia.
          </p>
          
          <div className="hero__actions">
            <button 
              onClick={scrollToForm}
              className="btn btn-primary hero__cta-primary"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
              </svg>
              Quero meu site/app
              <svg 
                width="20" 
                height="20" 
                viewBox="0 0 20 20" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  d="M4.16666 10H15.8333M15.8333 10L10.8333 5M15.8333 10L10.8333 15" 
                  stroke="currentColor" 
                  strokeWidth="1.67" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            
            <button 
              onClick={scrollToMore}
              className="btn btn-secondary hero__cta-secondary"
            >
              Ver mais
            </button>
          </div>
          
          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-number">50+</span>
              <span className="hero__stat-label">Projetos entregues</span>
            </div>
            <div className="hero__stat">
              <span className="hero__stat-number">24h</span>
              <span className="hero__stat-label">Resposta garantida</span>
            </div>
            <div className="hero__stat">
              <span className="hero__stat-number">100%</span>
              <span className="hero__stat-label">Personalizado</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero__scroll-indicator">
        <div className="hero__scroll-text">Role para descobrir</div>
        <div className="hero__scroll-arrow">
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M7 10L12 15L17 10" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 